import React from "react";
import FacebookIcon from "../assets/icons/facebook.svg";
import TwitterIcon from "../assets/icons/twitter.svg";
import LinkedInIcon from "../assets/icons/linkedin.svg";
import InstagramIcon from "../assets/icons/InstagramIcon.svg"
import GirlImage from "../assets/icons/GirlImage.png";
import { Button } from "@mui/material";
import {  FooterArrowContainer, FooterBottomBar, FooterCallText, FooterCard, FooterCardArrow, FooterCardContainer, FooterCardImage, FooterCardText, FooterContainer, FooterDivider, FooterImage, FooterInfoSection, FooterLink, FooterLinksSection, FooterLinkWrapper, FooterMobileLinkRow, FooterMobileLinkWrapper, FooterRightSection, FooterSocialIcon, FooterSocialIcons, FooterSocialText, FooterTitle, KnowMoreText } from "../assets/styles/FooterStyles";
import InstantCheckImage from "../assets/icons/InstantCheck.png";
import BackgroundCheckImage from "../assets/icons/BackgroundCheck.png";
import DueDiligenceImage from "../assets/icons/DueDiligence.png";
import PolygonArrow from "../assets/icons/polygon-arrow.png";
import { useNavigate } from "react-router-dom";


const Footer = () => {
  const handlePhoneClick = () => {
    const userConfirmed = window.confirm("Do you want to call 917259454868?");
    
    if (userConfirmed) {
      window.location.href = "tel:917259454868"; 
    }
  };
  const navigate = useNavigate(); 

  const handleNavigate = (path) => {
    window.scrollTo(0, 0); 
    navigate(path); 
  };
  return (
    <>
      <FooterContainer>
        <FooterInfoSection>
        <FooterCardContainer>
        <FooterCard>
          <FooterCardImage src={InstantCheckImage} alt="Instant Checks" />
          <FooterCardText>Instant Checks</FooterCardText>
        </FooterCard>
        <FooterArrowContainer>
          <FooterCardArrow src={PolygonArrow} alt="Arrow" />
          <KnowMoreText onClick={() => handleNavigate("/instant-checks")}>Know More</KnowMoreText>

        </FooterArrowContainer>
      </FooterCardContainer>

      <FooterCardContainer>
        <FooterCard>
          <FooterCardImage src={BackgroundCheckImage} alt="Background Checks" />
          <FooterCardText>Background Checks</FooterCardText>
        </FooterCard>
        <FooterArrowContainer>
          <FooterCardArrow src={PolygonArrow} alt="Arrow" />
          <KnowMoreText onClick={() => handleNavigate("/background-checks")}>Know More</KnowMoreText>

        </FooterArrowContainer>
      </FooterCardContainer>

      <FooterCardContainer>
        <FooterCard>
          <FooterCardImage src={DueDiligenceImage} alt="Due Diligence" />
          <FooterCardText>Due Diligence</FooterCardText>
        </FooterCard>
        <FooterArrowContainer>
          <FooterCardArrow src={PolygonArrow} alt="Arrow" />
          <KnowMoreText onClick={() => handleNavigate("/due-diligence")}>Know More</KnowMoreText>

        </FooterArrowContainer>
      </FooterCardContainer>
          {/* <FooterTitle>iScreening PVT. LTD.</FooterTitle>
          <FooterAddress>
            <strong>Bangalore Office:</strong>
            <br />
            108, Ramanashree Chambers, Tasker Road, Lady Curzon Street, Bangalore - 560001.
          </FooterAddress>
          <FooterAddress>
            <strong>Gurgaon Office:</strong>
            <br />
            Villa A-410 A, Indian Airlines Pilots Society, Sushant Lok Phase I, Gurugram, Haryana 122001.
          </FooterAddress>
          <FooterAddress>
            <strong>Jaipur Office:</strong>
            <br />
            A-660, Pink Hive, Calgiri Marg Opp. Rungta Hospital, Malviya Nagar, Jaipur.
          </FooterAddress> */}
        </FooterInfoSection>

        <FooterLinksSection>
          <FooterTitle>OUR COMPANY</FooterTitle>
          {/* Desktop View Links */}
          <FooterLinkWrapper>
          {/* <FooterLink onClick={() => handleNavigate("/careers")}>Careers</FooterLink> */}
          <FooterLink onClick={() => handleNavigate("/about-us")}>About Us</FooterLink>
          <FooterLink onClick={() => handleNavigate("/our-team")}>Our Team</FooterLink>
          <FooterLink onClick={() => handleNavigate("/privacy-policy")}>Privacy Policy</FooterLink>
          <FooterLink onClick={() => handleNavigate("/terms-and-conditions")}>Terms & Conditions</FooterLink>
          </FooterLinkWrapper>

          <FooterMobileLinkWrapper>
            <FooterMobileLinkRow>
              {/* <FooterLink onClick={() => handleNavigate("/careers")}>Careers</FooterLink> */}
              {/* <FooterDivider /> */}
              <FooterLink onClick={() => handleNavigate("/about-us")}>About Us</FooterLink>
              <FooterDivider />
              <FooterLink onClick={() => handleNavigate("/our-team")}>Our Team</FooterLink>
            </FooterMobileLinkRow>
            <FooterMobileLinkRow>
              <FooterLink onClick={() => handleNavigate("/privacy-policy")}>Privacy Policy</FooterLink>
              <FooterDivider />
              <FooterLink onClick={() => handleNavigate("/terms-and-conditions")}>Terms & Conditions</FooterLink>
            </FooterMobileLinkRow>
          </FooterMobileLinkWrapper>
        </FooterLinksSection>

        <FooterRightSection>
        <FooterImage src={GirlImage} alt="Representative" />
        <Button className="custom-button footer-button" variant="contained" onClick={() => navigate("/contact-us")}>
            Get Demo
          </Button>
        </FooterRightSection>
      </FooterContainer>

      <FooterBottomBar>
        <FooterCallText onClick={handlePhoneClick}>
        <span className="call-label">CALL</span>
        <span className="call-colon">:</span> 
        <span className="call-dot">.</span>
        <span className="bold-plus">+</span><span className="phone-number">91 72594 54868</span>
        </FooterCallText>
        <FooterSocialIcons>
          <FooterSocialText>Follow us on:</FooterSocialText>
          <a href="https://www.facebook.com/iscreening" target="_blank" rel="noopener noreferrer">
            <FooterSocialIcon src={FacebookIcon} alt="Facebook" />
          </a>
          <a href="https://x.com/iScreeningDevia" target="_blank" rel="noopener noreferrer">
            <FooterSocialIcon src={TwitterIcon} alt="Twitter" />
          </a>
          <a href="https://in.linkedin.com/company/iscreening-services-pvt-ltd" target="_blank" rel="noopener noreferrer">
            <FooterSocialIcon src={LinkedInIcon} alt="LinkedIn" />
          </a>
          <a href="https://www.instagram.com/iscreening_devia?igsh=MXJ2aWJ4MW4yNWc1YQ==" target="_blank" rel="noopener noreferrer">
            <FooterSocialIcon src={InstagramIcon} alt="InstagramIcon" />
          </a>
        </FooterSocialIcons>
      </FooterBottomBar>
    </>
  );
};

export default Footer;
